import React from 'react';
import IntroServiceWrapper from 'components/IntroServiceWrapper/IntroServiceWrapper';

export default function IntroServiceContainer() {
    return (
        <IntroServiceWrapper />
    )
}
